import { Alert } from '@ps/sports-ui-component-library';
import { Translation } from '@ps/web-shared-components';
import type { Odds as OddsType } from '@ps/web-sports-api-types';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { Odds } from '@swf/sports/components';

import { TXTWCL_Price_Changed_from_N0_to_N1, TXTWCL_SP } from './PriceChangeAlert.messages.json';
import styles from './PriceChangeAlert.scss';

interface Props {
  acceptedOdds: OddsType | undefined;
  currentOdds: OddsType | undefined;
}

const PriceChangeAlert: React.FC<Props> = ({ acceptedOdds, currentOdds }) => {
  const { formatMessage } = useRegulatoryIntl();
  const startingPrice = formatMessage(TXTWCL_SP);

  return (
    <Alert level="update" variant="passive" className={styles.priceUpdate}>
      <span>
        <Translation
          values={{
            previousOdds: acceptedOdds ? <Odds {...acceptedOdds} /> : startingPrice,
            newOdds: currentOdds ? <Odds {...currentOdds} /> : startingPrice
          }}
          {...TXTWCL_Price_Changed_from_N0_to_N1}
        />
      </span>
    </Alert>
  );
};

export default PriceChangeAlert;
